<soft-field-ok
  name="abteilung"
  placeholder="Abteilung"
  [title]="configuration()?.title ?? ''"
  [subtitle]="configuration()?.subtitle ?? ''"
  [parameters]="parameters()"
  [readonly]="readonly()"
  [value]="value()"
  (valueChange)="valueChange.emit($event)">
</soft-field-ok>
